import React from "react";
import s from "./BookingImpact.css";
import { flowRight as compose } from "lodash";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { FormattedMessage, injectIntl } from "react-intl";
import charity1 from "../../../../public/SiteIcons/charity1.svg";
import charity2 from "../../../../public/SiteIcons/charity2.svg";
import charity3 from "../../../../public/SiteIcons/charity3.svg";
import charity4 from "../../../../public/SiteIcons/charity4.svg";
import charity5 from "../../../../public/SiteIcons/charity5.svg";
import charity6 from "../../../../public/SiteIcons/charity6.svg";
import pawPrint from "../../../../public/SiteIcons/pawTwo.svg";
import pawPrintRight from "../../../../public/SiteIcons/pawOne.svg";
import arrowWhite from "../../../../public/SiteIcons/arrowWhite.svg";
import messages from "../../../locale/messages";

class BookingImpact extends React.Component {
  render() {
    return (
      <div className={s.bookingImpactSection}>
        <div className={s.container}>
          <h2 className={s.heading}>
            <FormattedMessage {...messages.bookingImpactHead} />
          </h2>
          <div className={s.subHeadingSection}>
            <p className={s.subHeading}>
              <FormattedMessage {...messages.bookingImpactSubHeading} />
            </p>
            <div className={s.description}>
              <p>
                <FormattedMessage {...messages.bookingImpactDes} />
              </p>
              <p>
                <FormattedMessage {...messages.bookingImpactDes2} />
              </p>
            </div>
          </div>

          <div className={s.cards}>
            {[
              {
                title: (
                  <FormattedMessage {...messages.bookingImpactListTitleOne} />
                ),
                text: (
                  <FormattedMessage {...messages.bookingImpactListTextOne} />
                ),
                img: charity1,
              },
              {
                title: (
                  <FormattedMessage {...messages.bookingImpactListTitleTwo} />
                ),
                text: (
                  <FormattedMessage {...messages.bookingImpactListTextTwo} />
                ),
                img: charity2,
              },
              {
                title: (
                  <FormattedMessage {...messages.bookingImpactListTitleThree} />
                ),
                text: (
                  <FormattedMessage {...messages.bookingImpactListTextThree} />
                ),
                img: charity3,
              },

              {
                title: (
                  <FormattedMessage {...messages.bookingImpactListTitleFour} />
                ),
                text: (
                  <FormattedMessage {...messages.bookingImpactListTextFour} />
                ),
                img: charity4,
              },
              {
                title: (
                  <FormattedMessage {...messages.bookingImpactListTitleFive} />
                ),
                text: (
                  <FormattedMessage {...messages.bookingImpactListTextFive} />
                ),
                img: charity5,
              },
              {
                title: (
                  <FormattedMessage {...messages.bookingImpactListTitleSix} />
                ),
                text: (
                  <FormattedMessage {...messages.bookingImpactListTextSix} />
                ),
                img: charity6,
              },
            ].map((card, index) => (
              <div key={index} className={s.card}>
                <img src={pawPrint} className={s.pawTop} />
                <img src={card.img} alt={card.title} className={s.cardImage} />
                <img src={card.img} alt={card.title} className={s.cardImage} />
                <h4 className={s.cardTitle}>{card.title}</h4>
                <p className={s.cardText}>{card.text}</p>

                <img src={pawPrintRight} className={s.pawBottom} />
              </div>
            ))}
          </div>

          {/* <button className={s.ctaBtn}>
            <FormattedMessage {...messages.learnMoreAbout} />{" "}
            <img src={arrowWhite} alt="Arrow" />
          </button> */}
        </div>
      </div>
    );
  }
}

export default compose(injectIntl, withStyles(s))(BookingImpact);
